import styled from '@emotion/styled';
import arrowUp from '../assets/images/arrow-up-grey-solid.svg';
import selectCheck from '../assets/images/select-check.png';
import selectCheckWhite from '../assets/images/select-check-white.png';
import { appTextColor, mediumGrey, menuSelectedColor, white, menuBackgroundColor, mediumDarkGrey } from './colors';

const _buttonTopPadding = 19;
const _arrowSidePadding = 0;
const _buttonTextToArrowSpace = 20;
const _fontSize = 12;
const _itemHeight = 21;
const _itemStartPad = 21;
const _arrowWidth = 14;
const _menuVertPad = 5;

export const menuStyle = {
  menuTopPad: _menuVertPad,
  itemHeight: _itemHeight,
  animateMenu: false,
  listMaxHeight: 10000,
  buttonBorderWidth: 0,
  listBorderWidth: 1,

  RSDropdownDiv: styled.div(() => {
    let style = {
      position: 'relative',
      width: '100%',
      height: '100%',
      outline: 'none'
    };
    return style;
  }),

  MenuButton: styled.div(() => {
    let style = {
      position: 'relative',
      cursor: 'pointer',
      width: '100%',
      height: 21,
      top: _buttonTopPadding,
      color: appTextColor,
      ':hover': {
        color: mediumDarkGrey
      },
      ':hover:active': {
        color: mediumGrey
      }
    };
    return style;
  }),

  MenuButtonLabel: styled.div((props) => {
    let style = {
      display: 'inline-block',
      paddingRight: '16px',
      fontSize: _fontSize,
      fontWeight: '700',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    };
    if (props.isRtl) {
      style.textAlign = 'right';
      style.left = _arrowWidth + _arrowSidePadding + _buttonTextToArrowSpace;
    } else {
      style.textAlign = 'left';
      style.right = _arrowWidth + _arrowSidePadding + _buttonTextToArrowSpace;
    }
    return style;
  }),

  MenuButtonArrow: styled.div((props) => {
    let style = {
      display: 'inline-block',
      backgroundImage: 'url(' + arrowUp + ')',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100% 100%',
      top: 0,
      width: _arrowWidth,
      height: _arrowWidth + 1
    };
    if (props.isRtl) {
      style.left = _arrowSidePadding;
      style.right = 'auto';
    } else {
      style.left = 'auto';
      style.right = _arrowSidePadding;
    }
    return style;
  }),

  MenuList: styled.ul((props) => {
    let style = {
      position: 'absolute',
      bottom: 36,
      top: 'auto',
      margin: 0,
      backgroundClip: 'padding-box',
      backgroundColor: menuBackgroundColor,
      borderColor: mediumGrey,
      border: '1px solid rgba(0,0,0,.15)',
      borderRadius: '4px',
      boxShadow: '0 6px 12px rgba(0,0,0,.175)',
      listStyle: 'none',
      paddingTop: _menuVertPad,
      paddingBottom: _menuVertPad,
      paddingLeft: 0,
      paddingRight: 0,
      width: 160,
      zIndex: '1000'
    };
    if (props.isRtl) {
      style.left = -8;
      style.right = 'auto';
    } else {
      style.left = 'auto';
      style.right = -8;
    }
    return style;
  }),

  MenuItem: styled.li((props) => {
    let style = {
      backgroundColor: 'transparent',
      color: appTextColor,
      fontSize: _fontSize,
      fontWeight: '700',
      letterSpacing: '0',
      height: _itemHeight,
      lineHeight: '16px',
      paddingLeft: _itemStartPad,
      paddingRight: 0,
      paddingTop: 3,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      backgroundPosition: '6px 6px',
      backgroundRepeat: 'no-repeat',
      textAlign: 'left'
    };
    if (props.highlight) {
      style.color = white;
      style.backgroundColor = menuSelectedColor;
    }
    if (props.selected) {
      if (props.highlight) {
        style.backgroundImage = 'url(' + selectCheckWhite + ')';
      } else {
        style.backgroundImage = 'url(' + selectCheck + ')';
      }
    }
    return style;
  })
};



// WEBPACK FOOTER //
// ./src/styles/InterfaceLanguageMenuStyle.js